import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import {bodyItems} from '../../elementsItems';
// import { valueAssigntoVariable } from '../../HTMLBuilderfunction';
import SwitchElementProperties  from '../ElementsProperties/SwitchElementProperties';

const BodyPropertiesTab = (props)=>{
    const {htmlContentItems} = props;

    const onChangeHandler = (path,key,val)=>{
        props.onChangePropertiesHandler(path,key,val,);
    }
    return(
        <div id="accordionExample" className="accordion">
            {isSet(bodyItems.properties,[]).map((section,secIndex)=>{
                return(
                    <div className="card card-transparent mb-2" key={secIndex}>
                        <div className="card-outer">
                            <div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
                                <div className="card-title d-flex align-items-center justify-content-between" id=" " data-toggle="collapse" href={"#accordin_"+secIndex} aria-expanded="true">
                                    <h6 className="mb-0"> {section.label} </h6>
                                    <div className="span-mode"></div>
                                </div>
					        </div>
                            <div className="form-body pt-2 p-2 collapse show" id={'accordin_'+secIndex} data-parent="#accordionExample" >
								<div className="row">
									<div className="col-12">
                                        {isSet(section.items,[]).map((item,itemIndex)=>{
                                            let value = '';
                                            const keyParam = '.'+item.keyParam;
                                                const path = item.path;
                                            try{                                                
                                                value = eval('htmlContentItems'+path+keyParam);
                                            }catch(e){
                                                // console.log('e',e);
                                            }

                                            let bodyIsCurrentData = {
                                                attributes:htmlContentItems.attributes,
                                                data:htmlContentItems.data,
                                                id:htmlContentItems.id,
                                                name:htmlContentItems.name,

                                            }
                                            
                                            return(
                                                <>
                                                <div className="crm_custFields third_dark_color mb-1  align-items-center Assignment">
										      		<div className="text-truncate pt-1">{item.label}</div>												      		
                                                      <SwitchElementProperties
                                                        value={value}
                                                        changeHandler={(path,key,val)=>onChangeHandler(path,key,val)}
                                                        {...props}
                                                        elementData={bodyIsCurrentData}
                                                        // elementData={currentElementData}
                                                        // onChangeHandler={props.onChangePropertiesHandler}
                                                        // onChangeHandler={(key,val)=>onChangePropertiesHandler(key,val)} 
                                                        {...item} 
                                                        isFrom='Body'
                                                    />																                                                               
												</div>
                                                <hr></hr></>
                                                
                                            )
                                        })} 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )  
            })} 
        </div>
    )
}

export default BodyPropertiesTab;